import React from 'react';
import { Link } from 'react-router-dom';

const Features = ({ settings = {} }) => {
  const {
    backgroundImage = '',
    button1Text = '',
    button1Link = '',
    button2Text = '',
    button2Link = '',
    title = ''
  } = settings;

  const sectionStyle = backgroundImage
    ? {
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url("${backgroundImage}")`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }
    : {};

  if (!button1Text && !button2Text && !title) return null;

  return (
    <section className="banner-section" style={sectionStyle}>
      <div className="banner-content">
        <div className="banner-inner text-center">
          {title && (
            <h2 className="banner-title text-white text-2xl md:text-3xl font-light mb-6">{title}</h2>
          )}
          <div className="flex flex-wrap justify-center gap-4">
            {button1Text && button1Link && (
              <Link
                to={button1Link}
                className="inline-block px-8 py-3 border border-white text-white bg-transparent hover:bg-white hover:text-black transition-colors text-sm font-medium"
                style={{ whiteSpace: 'nowrap' }}
              >
                {button1Text}
              </Link>
            )}
            {button2Text && button2Link && (
              <Link
                to={button2Link}
                className="inline-block px-8 py-3 border border-white text-white bg-transparent hover:bg-white hover:text-black transition-colors text-sm font-medium"
                style={{ whiteSpace: 'nowrap' }}
              >
                {button2Text}
              </Link>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;